<template>
  <div class="container-fluid">
    <splitpanes
      class="default-theme"
      :style="{ height: splitPaneHeight }"
      :size="10"
    >
      <pane
        size="20"
        max-size="50"
        v-bind:style="{
          float: 'left',
          'overflow-y': 'auto',
        }"
      >
        <div class="row" style="margin: 5px">
          <div class="col" style="text-align: center">
            <b-button-group>
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesToday"
                >{{ $store.state.localization.data.common.periodTimesOptions.today }}</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesYesterday"
                >{{ $store.state.localization.data.common.periodTimesOptions.yesterday }}</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesLastWeek"
                >{{ $store.state.localization.data.common.periodTimesOptions.lastWeek }}</b-button
              >
              <b-button
                style="font-size: 12px"
                variant="success"
                @click="selectedPeriodTimesLastMonth"
                >{{ $store.state.localization.data.common.periodTimesOptions.lastMonth }}</b-button
              >
            </b-button-group>
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-2" style="margin: 5px; font-size: 12px">
            <label>{{ $store.state.localization.data.common.beginPeriodLabel }}:</label>
          </div>
          <div class="col-5" style="margin: 5px">
            <input
              type="date"
              style="font-size: 12px; width: 120px"
              v-model="beginDate"
            />
          </div>
          <div class="col-3" style="margin: 5px">
            <input type="time" style="font-size: 12px" v-model="beginTime" />
          </div>
        </div>

        <div class="row no-gutters">
          <div class="col-2" style="margin: 5px; font-size: 12px">
            <label>{{ $store.state.localization.data.common.endPeriodLabel }}:</label>&Tab;
          </div>
          <div class="col-5" style="margin: 5px">
            <input
              type="date"
              style="font-size: 12px; width: 120px"
              v-model="endDate"
            />&Tab;
          </div>
          <div class="col-3" style="margin: 5px">
            <input type="time" style="font-size: 12px" v-model="endTime" />
          </div>
        </div>

        <div class="row">
          <div class="col" style="margin: 5px">
            <b-form-checkbox
              id="checkbox-1"
              v-model="isSummaryChart"
              ref="isSummaryChartRef"
              :disabled="
                charts.values.length != 1 ||
                (charts.values.length == 1 &&
                  charts.values[0].key == 'fuelTemperatureChart')
              "
            >
              {{ $store.state.localization.data.mainPage.charts.summaryChart }}
            </b-form-checkbox>
          </div>
          <div class="col" style="margin: 5px">
            <b-form-checkbox
              id="checkbox-2"
              v-model="isFuelTankDataTable"
              ref="isFuelTankDataTableRef"
            >
              {{ $store.state.localization.data.mainPage.charts.fuelTankDataTableLabel }}
            </b-form-checkbox>
          </div>
        </div>

        <div class="row">
          <div class="col" style="margin: 5px">
            <vue-multi-select
              v-model="charts.values"
              v-bind:filters="chartFilters"
              :options="charts.options"
              v-bind:selectOptions="chartSelectOptions"
              v-bind:btnLabel="chartBtnLabel"
            />
          </div>
        </div>

        <div class="row">
          <div class="col" style="margin: 5px">
             <b-form-select
              v-model="filterTanks.selected"
              :options="filterTanks.options"
              @change="selectFilterTanks($event)"
              style="font-size: 12px; width: 200px"
            ></b-form-select>
          </div>
        </div>

        <div class="row">
          <div class="col" style="margin: 5px">
            <vue-multi-select
              v-model="tanks.values"
              v-bind:filters="tankFilters"
              search
              v-bind:searchPlaceholder="$store.state.localization.data.mainPage.reports.searchLabel"
              :options="tanks.options"
              :selectOptions="tanks.data"
              v-bind:btnLabel="tankBtnLabel"
            />
          </div>
        </div>

        <div class="row">
          <div class="col" style="margin: 5px">
            <b-button
              style="font-size: 12px"
              class="btn-block"
              variant="success"
              :disabled="charts.values.length == 0 || tanks.values.length == 0"
              @click="getChart"
              >{{ $store.state.localization.data.mainPage.charts.getChartButton }}</b-button
            >
          </div>
        </div>
        <div class="row">
          <div class="col" style="margin: 5px">
            <div
              v-html="tableContent"
              class="text-center table-responsive"
            ></div>
          </div>
        </div>
      </pane>
      <pane size="80">
        
        <div class="text-center" v-show="isChartLoading">
          <div>
            <b-spinner
              label="Spinning"
              variant="success"
              style="width: 10rem; height: 10rem"
            ></b-spinner>
          </div>
        </div>
        <div class="row" v-show="!isChartLoading && chart != null">
          <div class="col text-right" style="margin: 5px">
            <b-button
              style="font-size: 12px"
              variant="success"
              :disabled="charts.values.length == 0 || tanks.values.length == 0"
              @click="resetZoom"
              >{{ $store.state.localization.data.mainPage.charts.resetZoomButton }}</b-button
            >
          </div>
        </div>
        <div class="row">
          <div
            ref="canvasContainer"
            class="col-12"
            style="position: relative; height: 90vh; width: 100vw"
          >
            <canvas ref="chartContainer"></canvas>
          </div>
        </div>
      </pane>
    </splitpanes>
    <b-modal ref="error-modal">
      <template v-slot:modal-header="{}">
        <div></div>
      </template>
      <div class="text-center" style="font-size: 12px">
        {{ this.serverError }}
      </div>
      <template v-slot:modal-footer="{ ok }">
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.hide
        }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import vueMultiSelect from "vue-multi-select";
import "vue-multi-select/dist/lib/vue-multi-select.css";
import Chart from "chart.js";
import zoom from "chartjs-plugin-zoom";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

import {
  chartService,
  utilsService,
  roleService,
  fuelTankService,
  filterService
} from "../../../services";

export default {
  name: "Charts",
  components: { Splitpanes, Pane, vueMultiSelect },
  props: {
    fuelTanks: Array,
  },
  data() {
    return {
      beginDate: null,
      beginTime: null,
      endDate: null,
      endTime: null,
      beginDateTime: null,
      endDateTime: null,
      isSummaryChart: false,
      isFuelTankDataTable: false,
      serverError: null,
      charts: {
        values: [],
        keys: [],
        options: {
          multi: true,
          labelName: "label",
        },
      },
      filterTanks: {
          selected: null,
          options: [],
      },
      tanks: {
        values: [],
        data: [],
        options: {
          multi: true,
          labelName: "label",
        },
      },
      isValidationError: false,
      isChartLoading: false,
      validationError: null,
      chartColors: null,
      chart: null,
      tableContent: "",
    };
  },
  computed: {
    splitPaneHeight() {
      const LEFT_TOP_POSITION_Y = 50;

      return `${document.documentElement.clientHeight - LEFT_TOP_POSITION_Y}px`;
    },
    chartFilters() {
      return [
        {
          nameAll: this.$store.state.localization.data.common.setAllLabel,
          nameNotAll: this.$store.state.localization.data.common.resetAllLabel,
          func() {
            return true;
          },
        },
      ];
    },
    chartSelectOptions() {
      const chartSelectOptions = [];

      for (let i = 0; i < this.charts.keys.length; i++) {
        chartSelectOptions.push({
          key: this.charts.keys[i],
          label:
            this.$store.state.localization.data.mainPage.charts.labels[
              this.charts.keys[i]
            ],
        });
      }

      return chartSelectOptions;
    },
    chartBtnLabel() {
      return (values) =>
        `${this.$store.state.localization.data.mainPage.charts.chartsButton}: (${values.length})`;
    },
    tankFilters() {
      return [
        {
          nameAll: this.$store.state.localization.data.common.setAllLabel,
          nameNotAll: this.$store.state.localization.data.common.resetAllLabel,
          func() {
            return true;
          },
        },
      ];
    },
    tankBtnLabel() {
      return (values) =>
        `${this.$store.state.localization.data.mainPage.reports.selectFilterValueLabel}: (${values.length})`;
    },
  },
  async created() {
    const today = new Date();

    const todayString = new Date(
      today.getTime() - today.getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10);

    this.beginDate = todayString;
    this.beginTime = "00:00:00";

    this.endDate = todayString;
    this.endTime = "23:59:00";

    this.chartColors = [
      {
        color: "rgb(75, 192, 192)",
      },
      {
        color: "rgb(255, 99, 132)",
      },
      {
        color: "rgb(54, 162, 235)",
      },
      {
        color: "rgb(153, 102, 255)",
      },
      {
        color: "rgb(255, 159, 64)",
      },
      {
        color: "rgb(255, 205, 86)",
      },
      {
        color: "rgb(201, 203, 207)",
      },
      {
        color: "rgb(102, 51, 0)",
      },
      {
        color: "rgb(255, 255, 0)",
      },
      {
        color: "rgb(102, 0, 102)",
      },
      {
        color: "rgb(0, 51, 0)",
      },
      {
        color: "rgb(0, 0, 102)",
      },
      {
        color: "rgb(255, 102, 0)",
      },
      {
        color: "rgb(255, 0, 102)",
      },
      {
        color: "rgb(204, 102, 255)",
      },
      {
        color: "rgb(153, 153, 255)",
      },
      {
        color: "rgb(102, 153, 153)",
      },
      {
        color: "rgb(0, 0, 153)",
      },
      {
        color: "rgb(0, 255, 255)",
      },
      {
        color: "rgb(102, 0, 204)",
      },
    ];

    this.filterTanks.options.push({
      value: "selectFilterLabel",
      text: this.$store.state.localization.data.mainPage.reports.selectFilterLabel
    });

    this.filterTanks.options.push({
      value: filterService.TANK_IDS_FILTER,
      text: this.$store.state.localization.data.mainPage.reports.fuelReport.filters.tankIds
    });

    this.filterTanks.options.push({
      value: filterService.COMPANY_ID_FILTER,
      text: this.$store.state.localization.data.mainPage.reports.fuelReport.filters.companyId
    });

    this.filterTanks.options.push({
      value: filterService.DEPO_FILTER,
      text: this.$store.state.localization.data.mainPage.reports.fuelReport.filters.depoId
    });

    this.filterTanks.selected = "selectFilterLabel";

    const chartsResponse = await chartService.getCharts();

    if (!chartsResponse.isSuccess) {
      //TODO: added error handling
      return;
    }

    for (let i = 0; i < chartsResponse.data.charts.length; i++) {
      this.charts.keys.push(chartsResponse.data.charts[i]);
    }
  },
  mounted() {
    //the ugliest way for changing styles of vue-multi-select element

    const chartsElementDiv = document.querySelector(
      "#app > div > div > div:nth-child(3) > div > div:nth-child(1) > div:nth-child(5) > div > div"
    );

    chartsElementDiv.style.width = "100%";

    const chartsElementButton = document.querySelector(
      "#app > div > div > div:nth-child(3) > div > div:nth-child(1) > div:nth-child(5) > div > div > button"
    );

    chartsElementButton.style.width = "100%";
    chartsElementButton.style.fontSize = "12px";
    chartsElementButton.style.textAlign = "left";

    const fuelTanksElementDiv = document.querySelector(
      "#app > div > div > div:nth-child(3) > div > div:nth-child(1) > div:nth-child(7) > div > div"
    );

    fuelTanksElementDiv.style.width = "100%";

    const fuelTanksElementButton = document.querySelector(
      "#app > div > div > div:nth-child(3) > div > div:nth-child(1) > div:nth-child(7) > div > div > button"
    );

    fuelTanksElementButton.style.width = "100%";
    fuelTanksElementButton.style.fontSize = "12px";
    fuelTanksElementButton.style.textAlign = "left";
  },
  methods: {
    selectFilterTanks(event) {
      this.tanks.data = [];
      this.tanks.values = [];

      if (!event) {
        return;
      }

      if (event == filterService.TANK_IDS_FILTER) {
        this.tanks.data = filterService.createFilterByFuelTanks(this.fuelTanks);
      } else if (event == filterService.COMPANY_ID_FILTER) {
        this.tanks.data = filterService.createFilterByCompanies(this.fuelTanks);
      } else if (event == filterService.DEPO_FILTER) {
        this.tanks.data = filterService.createFilterByDepos(this.fuelTanks);
      } else if (event == filterService.DRIVER_IDS_FILTER) {
        this.tanks.data = filterService.createFilterByDrivers(this.drivers);
      }
    },
    async getChart() {
      console.log(zoom);

      if (this.chart) {
        this.chart.destroy();
      }

      this.beginDateTime = new Date(
        (this.beginDate + " " + this.beginTime).replace(/-/g, "/")
      );
      this.endDateTime = new Date(
        (this.endDate + " " + this.endTime).replace(/-/g, "/")
      );

      if (isNaN(this.beginDateTime)) {
        this.validationError =
          this.$store.state.localization.data.common.validations.beginPeriod;
        this.isValidationError = true;

        return;
      }

      if (isNaN(this.endDateTime)) {
        this.validationError =
          this.$store.state.localization.data.common.validations.endPeriod;
        this.isValidationError = true;

        return;
      }

      if (this.beginDateTime > this.endDateTime) {
        this.validationError =
          this.$store.state.localization.data.common.validations.endPeriodInvalid;
        this.isValidationError = true;

        return;
      }

      if (this.charts.values.length == 0) {
        this.validationError =
          this.$store.state.localization.data.mainPage.charts.validations.charts;
        this.isValidationError = true;

        return;
      }

      if (this.tanks.values.length == 0) {
        this.validationError =
          this.$store.state.localization.data.mainPage.charts.validations.fuelTanks;
        this.isValidationError = true;

        return;
      }

      try {
        this.isChartLoading = true;

        const isAccountingSystem =
          this.$store.state.authentication.roles.indexOf(
            roleService.CHARTS_ACCOUNTING_SYSTEM_READ_ROLE
          ) != -1;

        const fuelChartResponse = await chartService.getFuelChart(
          this.beginDateTime,
          this.endDateTime,
          this.charts.values,
          isAccountingSystem,
          this.tanks,
          this.filterTanks.selected,
          this.fuelTanks
        );

        if (fuelChartResponse.isSuccess) {
          if (fuelChartResponse.data.charts && fuelChartResponse.data.charts.length != 0) {
            const normalizedData = this.normalizeData(
              fuelChartResponse.data.charts
            );
  
            const isSummaryChartRef = this.$refs["isSummaryChartRef"];
  
            if (this.isSummaryChart && !isSummaryChartRef.disabled) {
              this.addSummaryChart(normalizedData);
            }
            this.showCharts(normalizedData);
  
            this.tableContent = "";
  
            if (this.isFuelTankDataTable) {
              const fuelTankData = await fuelTankService.getFuelTankData(
                this.beginDateTime,
                this.endDateTime,
                this.tanks,
                this.filterTanks.selected,
                this.fuelTanks
              );
  
              if (fuelTankData.data.fuelTanks.length != 0) {
                this.fillFuelTankDataTable(fuelTankData.data.fuelTanks[0]);
              }
            }
          } else {
            this.serverError = this.$store.state.localization.data.mainPage.charts.emptyDataError;
            this.$refs["error-modal"].show();
          }
        } else {
          this.isValidationError = true;
          this.validationError = fuelChartResponse.data;

          if (fuelChartResponse.data.error == "invalidParameter") {
            if (fuelChartResponse.data.localizationParameters && fuelChartResponse.data.localizationParameters.ParameterName == "BeginTime or EndTime") {
              this.serverError = this.$store.state.localization.data.mainPage.charts.maxTimePeriodError;
            } else if (fuelChartResponse.data.localizationParameters && fuelChartResponse.data.localizationParameters.ParameterName == "TankIds.Length, Charts.Length") {
              this.serverError = this.$store.state.localization.data.mainPage.charts.maxCountItemsPeriodError;
            } else {
              this.serverError = this.$store.state.localization.data.mainPage.charts.getDataError;
            }
            this.$refs["error-modal"].show();
          }
        }
      } catch (error) {
        console.log(error);
        this.validationError = error;
      }

      this.isChartLoading = false;
    },
    selectedPeriodTimesToday() {
      const today = new Date();

      const beginDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = beginDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesYesterday() {
      const today = new Date();

      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);

      const beginDateString = new Date(
        yesterday.getTime() - yesterday.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = beginDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesLastWeek() {
      const today = new Date();

      const lastWeek = new Date(today);
      lastWeek.setDate(today.getDate() - 7);

      const beginDateString = new Date(
        lastWeek.getTime() - lastWeek.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      const endDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = endDateString;
      this.endTime = "23:59:00";
    },
    selectedPeriodTimesLastMonth() {
      const today = new Date();

      const lastMonth = new Date(today);
      lastMonth.setDate(today.getDate() - 30);

      const beginDateString = new Date(
        lastMonth.getTime() - lastMonth.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      const endDateString = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      this.beginDate = beginDateString;
      this.beginTime = "00:00:00";

      this.endDate = endDateString;
      this.endTime = "23:59:00";
    },
    normalizeData(charts) {
      let indexMainChart = 0;

      for (let i = 0; i < charts.length; i++) {
        if (charts[i].times.length > charts[indexMainChart].times.length) {
          indexMainChart = i;
        }
      }

      const mainChart = charts[indexMainChart];

      const normalizedData = {
        times: mainChart.times,
        charts: [],
        maxValue: 0,
      };

      for (let i = 0; i < charts.length; i++) {
        const chart = {
          tankId: charts[i].tankId,
          fuelVolumes: [],
          fuelVolumes15: [],
          fuelWeights: [],
          fuelTemperatures: [],
          accountingFuelVolumes: [],
          accountingFuelVolumes15: [],
          accountingFuelWeights: [],
          fuelLevels: [],
          waterLevels: [],
          isSummary: false,
        };

        if (i != indexMainChart) {
          let currentIndex = 0;

          for (let j = 0; j < mainChart.times.length; j++) {
            if (mainChart.times[j] <= charts[i].times[currentIndex]) {
              if (charts[i].fuelVolumes) {
                chart.fuelVolumes.push(charts[i].fuelVolumes[currentIndex]);

                if (
                  normalizedData.maxValue < charts[i].fuelVolumes[currentIndex]
                ) {
                  normalizedData.maxValue = charts[i].fuelVolumes[currentIndex];
                }
              }

              if (charts[i].fuelVolumes15) {
                chart.fuelVolumes15.push(charts[i].fuelVolumes15[currentIndex]);

                if (
                  normalizedData.maxValue <
                  charts[i].fuelVolumes15[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].fuelVolumes15[currentIndex];
                }
              }

              if (charts[i].fuelWeights) {
                chart.fuelWeights.push(charts[i].fuelWeights[currentIndex]);

                if (
                  normalizedData.maxValue < charts[i].fuelWeights[currentIndex]
                ) {
                  normalizedData.maxValue = charts[i].fuelWeights[currentIndex];
                }
              }

              if (charts[i].fuelTemperatures) {
                chart.fuelTemperatures.push(
                  charts[i].fuelTemperatures[currentIndex]
                );

                if (
                  normalizedData.maxValue <
                  charts[i].fuelTemperatures[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].fuelTemperatures[currentIndex];
                }
              }

              if (charts[i].accountingFuelVolumes) {
                chart.accountingFuelVolumes.push(
                  charts[i].accountingFuelVolumes[currentIndex]
                );

                if (
                  normalizedData.maxValue <
                  charts[i].accountingFuelVolumes[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].accountingFuelVolumes[currentIndex];
                }
              }

              if (charts[i].accountingFuelVolumes15) {
                chart.accountingFuelVolumes15.push(
                  charts[i].accountingFuelVolumes15[currentIndex]
                );

                if (
                  normalizedData.maxValue <
                  charts[i].accountingFuelVolumes15[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].accountingFuelVolumes15[currentIndex];
                }
              }

              if (charts[i].accountingFuelWeights) {
                chart.accountingFuelWeights.push(
                  charts[i].accountingFuelWeights[currentIndex]
                );

                if (
                  normalizedData.maxValue <
                  charts[i].accountingFuelWeights[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].accountingFuelWeights[currentIndex];
                }
              }

              if (charts[i].fuelLevels) {
                chart.fuelLevels.push(charts[i].fuelLevels[currentIndex] / 10);

                if (
                  normalizedData.maxValue < charts[i].fuelLevels[currentIndex] / 10
                ) {
                  normalizedData.maxValue = charts[i].fuelLevels[currentIndex] / 10;
                }
              }

              if (charts[i].waterLevels) {
                chart.waterLevels.push(charts[i].waterLevels[currentIndex] / 10);

                if (
                  normalizedData.maxValue < charts[i].waterLevels[currentIndex] / 10
                ) {
                  normalizedData.maxValue = charts[i].waterLevels[currentIndex] / 10;
                }
              }
            } else {
              if (currentIndex < charts[i].times.length - 1) {
                currentIndex++;
              }

              if (charts[i].fuelVolumes) {
                chart.fuelVolumes.push(charts[i].fuelVolumes[currentIndex]);

                if (
                  normalizedData.maxValue < charts[i].fuelVolumes[currentIndex]
                ) {
                  normalizedData.maxValue = charts[i].fuelVolumes[currentIndex];
                }
              }

              if (charts[i].fuelVolumes15) {
                chart.fuelVolumes15.push(charts[i].fuelVolumes15[currentIndex]);

                if (
                  normalizedData.maxValue <
                  charts[i].fuelVolumes15[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].fuelVolumes15[currentIndex];
                }
              }

              if (charts[i].fuelWeights) {
                chart.fuelWeights.push(charts[i].fuelWeights[currentIndex]);

                if (
                  normalizedData.maxValue < charts[i].fuelWeights[currentIndex]
                ) {
                  normalizedData.maxValue = charts[i].fuelWeights[currentIndex];
                }
              }

              if (charts[i].fuelTemperatures) {
                chart.fuelTemperatures.push(
                  charts[i].fuelTemperatures[currentIndex]
                );

                if (
                  normalizedData.maxValue <
                  charts[i].fuelTemperatures[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].fuelTemperatures[currentIndex];
                }
              }

              if (charts[i].accountingFuelVolumes) {
                chart.accountingFuelVolumes.push(
                  charts[i].accountingFuelVolumes[currentIndex]
                );

                if (
                  normalizedData.maxValue <
                  charts[i].accountingFuelVolumes[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].accountingFuelVolumes[currentIndex];
                }
              }

              if (charts[i].accountingFuelVolumes15) {
                chart.accountingFuelVolumes15.push(
                  charts[i].accountingFuelVolumes15[currentIndex]
                );

                if (
                  normalizedData.maxValue <
                  charts[i].accountingFuelVolumes15[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].accountingFuelVolumes15[currentIndex];
                }
              }

              if (charts[i].accountingFuelWeights) {
                chart.accountingFuelWeights.push(
                  charts[i].accountingFuelWeights[currentIndex]
                );

                if (
                  normalizedData.maxValue <
                  charts[i].accountingFuelWeights[currentIndex]
                ) {
                  normalizedData.maxValue =
                    charts[i].accountingFuelWeights[currentIndex];
                }
              }

              if (charts[i].fuelLevels) {
                chart.fuelLevels.push(charts[i].fuelLevels[currentIndex] / 10);

                if (
                  normalizedData.maxValue < charts[i].fuelLevels[currentIndex] / 10
                ) {
                  normalizedData.maxValue = charts[i].fuelLevels[currentIndex] / 10;
                }
              }

              if (charts[i].waterLevels) {
                chart.waterLevels.push(charts[i].waterLevels[currentIndex] / 10);

                if (
                  normalizedData.maxValue < charts[i].waterLevels[currentIndex] / 10
                ) {
                  normalizedData.maxValue = charts[i].waterLevels[currentIndex] / 10;
                }
              }
            }
          }
        } else {
          if (charts[i].fuelVolumes) {
            chart.fuelVolumes = charts[i].fuelVolumes;

            for (let j = 0; j < charts[i].fuelVolumes.length; j++) {
              if (normalizedData.maxValue < charts[i].fuelVolumes[j]) {
                normalizedData.maxValue = charts[i].fuelVolumes[j];
              }
            }
          }

          if (charts[i].fuelVolumes15) {
            chart.fuelVolumes15 = charts[i].fuelVolumes15;

            for (let j = 0; j < charts[i].fuelVolumes15.length; j++) {
              if (normalizedData.maxValue < charts[i].fuelVolumes15[j]) {
                normalizedData.maxValue = charts[i].fuelVolumes15[j];
              }
            }
          }

          if (charts[i].fuelWeights) {
            chart.fuelWeights = charts[i].fuelWeights;

            for (let j = 0; j < charts[i].fuelWeights.length; j++) {
              if (normalizedData.maxValue < charts[i].fuelWeights[j]) {
                normalizedData.maxValue = charts[i].fuelWeights[j];
              }
            }
          }

          if (charts[i].fuelTemperatures) {
            chart.fuelTemperatures = charts[i].fuelTemperatures;

            for (let j = 0; j < charts[i].fuelTemperatures.length; j++) {
              if (normalizedData.maxValue < charts[i].fuelTemperatures[j]) {
                normalizedData.maxValue = charts[i].fuelTemperatures[j];
              }
            }
          }

          if (charts[i].accountingFuelVolumes) {
            chart.accountingFuelVolumes = charts[i].accountingFuelVolumes;

            for (let j = 0; j < charts[i].accountingFuelVolumes.length; j++) {
              if (
                normalizedData.maxValue < charts[i].accountingFuelVolumes[j]
              ) {
                normalizedData.maxValue = charts[i].accountingFuelVolumes[j];
              }
            }
          }

          if (charts[i].accountingFuelVolumes15) {
            chart.accountingFuelVolumes15 = charts[i].accountingFuelVolumes15;

            for (let j = 0; j < charts[i].accountingFuelVolumes15.length; j++) {
              if (
                normalizedData.maxValue < charts[i].accountingFuelVolumes15[j]
              ) {
                normalizedData.maxValue = charts[i].accountingFuelVolumes15[j];
              }
            }
          }

          if (charts[i].accountingFuelWeights) {
            chart.accountingFuelWeights = charts[i].accountingFuelWeights;

            for (let j = 0; j < charts[i].accountingFuelWeights.length; j++) {
              if (
                normalizedData.maxValue < charts[i].accountingFuelWeights[j]
              ) {
                normalizedData.maxValue = charts[i].accountingFuelWeights[j];
              }
            }
          }

          if (charts[i].fuelLevels) {
            for (let j = 0; j < charts[i].fuelLevels.length; j++) {
              chart.fuelLevels.push(charts[i].fuelLevels[j] / 10);

              if (normalizedData.maxValue < charts[i].fuelLevels[j]) {
                normalizedData.maxValue = charts[i].fuelLevels[j];
              }
            }
          }

          if (charts[i].waterLevels) {
            for (let j = 0; j < charts[i].waterLevels.length; j++) {
              chart.waterLevels.push(charts[i].waterLevels[j] / 10);

              if (normalizedData.maxValue < charts[i].waterLevels[j]) {
                normalizedData.maxValue = charts[i].waterLevels[j];
              }
            }
          }
        }

        normalizedData.charts.push(chart);
      }

      return normalizedData;
    },
    addSummaryChart(data) {
      const summaryChart = {
        tankId: null,
        fuelVolumes: [],
        fuelVolumes15: [],
        fuelWeights: [],
        fuelTemperatures: [],
        accountingFuelVolumes: [],
        accountingFuelVolumes15: [],
        accountingFuelWeights: [],
        fuelLevels: [],
        waterLevels: [],
        isSummary: true,
      };

      for (let i = 0; i < data.charts.length; i++) {
        if (i == 0) {
          for (let j = 0; j < data.charts[i].fuelVolumes.length; j++) {
            summaryChart.fuelVolumes[j] = data.charts[i].fuelVolumes[j];
          }

          for (let j = 0; j < data.charts[i].fuelVolumes15.length; j++) {
            summaryChart.fuelVolumes15[j] = data.charts[i].fuelVolumes15[j];
          }

          for (let j = 0; j < data.charts[i].fuelWeights.length; j++) {
            summaryChart.fuelWeights[j] = data.charts[i].fuelWeights[j];
          }

          for (
            let j = 0;
            j < data.charts[i].accountingFuelVolumes.length;
            j++
          ) {
            summaryChart.accountingFuelVolumes[j] =
              data.charts[i].accountingFuelVolumes[j];
          }

          for (
            let j = 0;
            j < data.charts[i].accountingFuelVolumes15.length;
            j++
          ) {
            summaryChart.accountingFuelVolumes15[j] =
              data.charts[i].accountingFuelVolumes15[j];
          }

          for (
            let j = 0;
            j < data.charts[i].accountingFuelWeights.length;
            j++
          ) {
            summaryChart.accountingFuelWeights[j] =
              data.charts[i].accountingFuelWeights[j];
          }

          for (let j = 0; j < data.charts[i].fuelLevels.length; j++) {
            summaryChart.fuelLevels[j] = data.charts[i].fuelLevels[j];
          }

          for (let j = 0; j < data.charts[i].waterLevels.length; j++) {
            summaryChart.waterLevels[j] = data.charts[i].waterLevels[j];
          }
        } else {
          for (let j = 0; j < data.charts[i].fuelVolumes.length; j++) {
            summaryChart.fuelVolumes[j] += data.charts[i].fuelVolumes[j];
          }

          for (let j = 0; j < data.charts[i].fuelVolumes15.length; j++) {
            summaryChart.fuelVolumes15[j] += data.charts[i].fuelVolumes15[j];
          }

          for (let j = 0; j < data.charts[i].fuelWeights.length; j++) {
            summaryChart.fuelWeights[j] += data.charts[i].fuelWeights[j];
          }

          for (
            let j = 0;
            j < data.charts[i].accountingFuelVolumes.length;
            j++
          ) {
            summaryChart.accountingFuelVolumes[j] +=
              data.charts[i].accountingFuelVolumes[j];
          }

          for (
            let j = 0;
            j < data.charts[i].accountingFuelVolumes15.length;
            j++
          ) {
            summaryChart.accountingFuelVolumes15[j] +=
              data.charts[i].accountingFuelVolumes15[j];
          }

          for (
            let j = 0;
            j < data.charts[i].accountingFuelWeights.length;
            j++
          ) {
            summaryChart.accountingFuelWeights[j] +=
              data.charts[i].accountingFuelWeights[j];
          }

          for (let j = 0; j < data.charts[i].fuelLevels.length; j++) {
            summaryChart.fuelLevels[j] += data.charts[i].fuelLevels[j];
          }

          for (let j = 0; j < data.charts[i].waterLevels.length; j++) {
            summaryChart.waterLevels[j] += data.charts[i].waterLevels[j];
          }
        }
      }

      data.charts.push(summaryChart);
    },
    getTank(tankId) {
      const tankIdParts = tankId.split(":");

      for (let i = 0; i < this.fuelTanks.length; i++) {
        if (this.fuelTanks[i].vehicleId == tankIdParts[0] && this.fuelTanks[i].fuelTankId == tankIdParts[1]) {
          return this.fuelTanks[i];
        }
      }
    },
    showCharts(data) {
      const datasets = [];
      const yAxes = [];
      const yAxesKeys = {};

      let countCharts = 0;

      const chartsMetaData = {
        fuelVolumeChart: {
          label:
            this.$store.state.localization.data.mainPage.charts.fuelVolumeChart
              .label,
          propertyName: "fuelVolumes",
          unit: this.$store.state.localization.data.mainPage.charts
            .fuelVolumeChart.unit,
        },
        fuelVolume15Chart: {
          label:
            this.$store.state.localization.data.mainPage.charts
              .fuelVolumeChart15.label,
          propertyName: "fuelVolumes15",
          unit: this.$store.state.localization.data.mainPage.charts
            .fuelVolumeChart15.unit,
        },
        fuelTemperatureChart: {
          label:
            this.$store.state.localization.data.mainPage.charts
              .fuelTemperatureChart.label,
          propertyName: "fuelTemperatures",
          unit: this.$store.state.localization.data.mainPage.charts
            .fuelTemperatureChart.unit,
        },
        fuelWeightChart: {
          label:
            this.$store.state.localization.data.mainPage.charts.fuelWeightChart
              .label,
          propertyName: "fuelWeights",
          unit: this.$store.state.localization.data.mainPage.charts
            .fuelWeightChart.unit,
        },
        accountingFuelVolumeChart: {
          label:
            this.$store.state.localization.data.mainPage.charts
              .accountingFuelVolumeChart.label,
          propertyName: "accountingFuelVolumes",
          unit: this.$store.state.localization.data.mainPage.charts
            .accountingFuelVolumeChart.unit,
        },
        accountingFuelVolume15Chart: {
          label:
            this.$store.state.localization.data.mainPage.charts
              .accountingFuelVolume15Chart.label,
          propertyName: "accountingFuelVolumes15",
          unit: this.$store.state.localization.data.mainPage.charts
            .accountingFuelVolume15Chart.unit,
        },
        accountingFuelWeightChart: {
          label:
            this.$store.state.localization.data.mainPage.charts
              .accountingFuelWeightChart.label,
          propertyName: "accountingFuelWeights",
          unit: this.$store.state.localization.data.mainPage.charts
            .accountingFuelWeightChart.unit,
        },
        fuelLevelChart: {
          label:
            this.$store.state.localization.data.mainPage.charts.fuelLevelChart
              .label,
          propertyName: "fuelLevels",
          unit: this.$store.state.localization.data.mainPage.charts
            .fuelLevelChart.unit,
        },
        waterLevelChart: {
          label:
            this.$store.state.localization.data.mainPage.charts.waterLevelChart
              .label,
          propertyName: "waterLevels",
          unit: this.$store.state.localization.data.mainPage.charts
            .waterLevelChart.unit,
        },
      };

      const toolTips = [];
      const canvas = this.$refs["chartContainer"];

      for (let i = 0; i < data.charts.length; i++) {
        const tank = this.getTank(data.charts[i].tankId);

        const tankName = tank ? tank.fuelTankName : this.$store.state.localization.data.mainPage.charts.summaryChart;

        for (let j = 0; j < this.charts.values.length; j++) {
          const metadata = chartsMetaData[this.charts.values[j].key];

          if (data.charts[i][metadata.propertyName].length != 0) {
            datasets.push({
              label: `${tankName}: ${this.charts.values[j].label}`,
              yAxisID: this.charts.values[j].label,
              backgroundColor: this.chartColors[countCharts].color,
              borderColor: this.chartColors[countCharts].color,
              borderWidth: 3,
              data: data.charts[i][metadata.propertyName],
              fill: false,
              pointRadius: 2,
              lineTension: 0,
            });

            toolTips.push({
              datasetIndex: datasets.length - 1,
              propertyName: metadata.propertyName,
              label: metadata.label,
              unit: metadata.unit,
            });

            if (!yAxesKeys[this.charts.values[j].label]) {
              yAxes.push({
                display: true,
                id: this.charts.values[j].label,
                type: "linear",
                scaleLabel: {
                  display: true,
                  labelString: `${metadata.label}, ${metadata.unit}`,
                  fontSize: 12,
                },
                ticks: {
                  beginAtZero: true,
                },
              });

              yAxesKeys[this.charts.values[j].label] = true;
            }

            if (countCharts < this.chartColors.length - 1) {
              countCharts++;
            }
          }
        }
      }

      this.chart = new Chart(canvas, {
        type: "line",
        data: {
          labels: data.times.map((item) => {
            return item * 1000; //need to convert from seconds to milliseconds
          }),
          datasets: datasets,
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: false,
          scales: {
            xAxes: [
              {
                display: true,
                type: "time",
                time: {
                  parser: "X", //parse x values as unix timestamp
                  round: "second",
                  unit: "hour",
                  tooltipFormat: "DD.MM.YYYY HH:mm:ss",
                  displayFormats: {
                    hour: "DD.MM.YYYY HH:mm:ss",
                  },
                },
                scaleLabel: {
                  display: true,
                  labelString: this.$store.state.localization.data.common.time,
                  fontSize: 12,
                },
              },
            ],
            yAxes: yAxes,
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem) {
                const pointToolTip = toolTips.find((item) => {
                  return item.datasetIndex == tooltipItem.datasetIndex;
                });

                if (
                  pointToolTip.propertyName == "fuelVolumes" ||
                  pointToolTip.propertyName == "accountingFuelVolumes" ||
                  pointToolTip.propertyName == "fuelVolumes15" ||
                  pointToolTip.propertyName == "accountingFuelVolumes15" ||
                  pointToolTip.propertyName == "fuelWeights" ||
                  pointToolTip.propertyName == "accountingFuelWeights" ||
                  pointToolTip.propertyName == "fuelLevels" ||
                  pointToolTip.propertyName == "waterLevels"
                ) {
                  return `${pointToolTip.label}: ${utilsService.formatNumber(
                    tooltipItem.yLabel,
                    1
                  )}, ${pointToolTip.unit}`;
                } else {
                  return `${pointToolTip.label}: ${utilsService.formatNumber(
                    tooltipItem.yLabel,
                    2
                  )}, ${pointToolTip.unit}`;
                }
              },
            },
          },
          plugins: {
            zoom: {
              pan: {
                enabled: true,
                mode: "xy",
                speed: 5,
                rangeMin: {
                  x: new Date(data.times[0] * 1000),
                  y: 0,
                },
                rangeMax: {
                  x: new Date(data.times[data.times.length - 1] * 1000),
                  y: 5 * data.maxValue,
                },
              },
              zoom: {
                enabled: true,
                mode: "xy",
                speed: 0.2,
                rangeMin: {
                  x: new Date(data.times[0] * 1000),
                  y: 0,
                },
                rangeMax: {
                  x: new Date(data.times[data.times.length - 1] * 1000),
                  y: 5 * data.maxValue,
                },
              },
            },
          },
        },
      });
    },
    resetZoom() {
      this.chart.resetZoom();
    },
    fillFuelTankDataTable(data) {
      const rows = [];

      rows.push(
        `<tr><td class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;' colspan='10'>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.beginPeriod}</td></tr>`
      );

      rows.push(
        `<tr class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;'>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.time}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolume}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolumeAccounting}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVoulemDiff}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolume15}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolume15Accounting}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelTemperature}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelLevel}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelWeight}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelWeightAccounting}</td>
          </tr>`
      );

      rows.push(
        `<tr class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;'>
          <td>${utilsService.formatDateTime(
            this.beginDateTime,
            utilsService.DATE_TIME_FORMAT
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.beginFuelVolume,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataAccountingSystem.beginFuelVolume,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataDiff.beginFuelVolumeDiff,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.beginFuelVolume15,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataAccountingSystem.beginFuelVolume15,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.beginFuelTemperature,
            1
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.beginFuelLevel,
            1
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.beginFuelWeight,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataAccountingSystem.beginFuelWeight,
            2
          )}</td>
          </tr>`
      );

      rows.push(
        `<tr><td class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;' colspan='10'>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.endPeriod}</td></tr>`
      );

      rows.push(
        `<tr class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;'>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.time}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolume}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolumeAccounting}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVoulemDiff}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolume15}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolume15Accounting}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelTemperature}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelLevel}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelWeight}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelWeightAccounting}</td>
          </tr>`
      );

      rows.push(
        `<tr class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;'>
          <td>${utilsService.formatDateTime(
            this.endDateTime,
            utilsService.DATE_TIME_FORMAT
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.endFuelVolume,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataAccountingSystem.endFuelVolume,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataDiff.endFuelVolumeDiff,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.endFuelVolume15,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataAccountingSystem.endFuelVolume15,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.endFuelTemperature,
            1
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.endFuelLevel,
            1
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.endFuelWeight,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataAccountingSystem.endFuelWeight,
            2
          )}</td>
          </tr>`
      );

      rows.push(
        `<tr><td class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;' colspan='8'>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.diffPeriod}</td></tr>`
      );

      rows.push(
        `<tr class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;'>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.time}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolume}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVolumeAccounting}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.fuelVoulemDiff}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.inFuelVolume}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.inFuelVolumeAccounting}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.outFuelVolume}</td>
          <td>${this.$store.state.localization.data.mainPage.charts.fuelTankDataTable.outFuelVolumeAccounting}</td>
          </tr>`
      );

      rows.push(
        `<tr class='table-b-table-default b-table-sticky-column' style='text-align:center; vertical-align:middle;'>
          <td>${data.fuelTankDataDiff.timeDiff}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataDiff.fuelVolume,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataDiff.fuelVolumeAccountingSystem,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataDiff.fuelVolumeDiff,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.fuelVolumeCharge,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataAccountingSystem.fuelVolumeCharge,
            2
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankData.fuelVolumeDischarge,
            1
          )}</td>
          <td>${utilsService.formatNumber(
            data.fuelTankDataAccountingSystem.fuelVolumeDischarge,
            1
          )}</td>
          </tr>`
      );

      this.tableContent = `<table role='table' aria-busy='false' class='table b-table table-hover table-bordered table-sm'><tbody>${rows.join(
        ""
      )}</tbody></table>`;
    },
  },
};
</script>

<style>
.textMiddle {
  vertical-align: middle !important;
  text-align: center !important;
  min-width: 20px !important;
}
</style>
